import { Span } from "@tblabs/truffle";


export class Bold extends Span
{
    constructor(text: string)
    {
        super(text);

        this.Bold();
    }
}
